const data_switches={
    "message": "success",
    "success": true,
    "data": [
      {
        "name": "Interface Bridge-Aggregation2: Operational status",
        "Date": "24/11/2023 10:37:06",
        "Metric": 1,
        "hostidP": 11920,
        "latitude_p": "21.0096275",
        "longitude_p": "-101.513399",
        "hostidC": 11926,
        "latitude_c": "21.129355",
        "longitude_c": "-101.720827",
        "portC": "2"
      },
      {
        "name": "Interface Bridge-Aggregation2: Operational status",
        "Date": "24/11/2023 07:47:09",
        "Metric": 1,
        "hostidP": 11920,
        "latitude_p": "21.0096275",
        "longitude_p": "-101.513399",
        "hostidC": 11929,
        "latitude_c": "20.9524967",
        "longitude_c": "-101.444063",
        "portC": "2"
      },
      {
        "name": "Interface Bridge-Aggregation3: Operational status",
        "Date": "24/11/2023 10:37:03",
        "Metric": 1,
        "hostidP": 11920,
        "latitude_p": "21.0096275",
        "longitude_p": "-101.513399",
        "hostidC": 11923,
        "latitude_c": "21.0218106",
        "longitude_c": "-101.258738",
        "portC": "3"
      },
      {
        "name": "Interface Bridge-Aggregation3: Operational status",
        "Date": "24/11/2023 10:37:04",
        "Metric": 1,
        "hostidP": 11923,
        "latitude_p": "21.0218106",
        "longitude_p": "-101.258738",
        "hostidC": 11924,
        "latitude_c": "21.0218106",
        "longitude_c": "-101.258738",
        "portC": "3"
      },
      {
        "name": "Interface Bridge-Aggregation3: Operational status",
        "Date": "24/11/2023 10:37:04",
        "Metric": 1,
        "hostidP": 11920,
        "latitude_p": "21.0096275",
        "longitude_p": "-101.513399",
        "hostidC": 11924,
        "latitude_c": "21.0218106",
        "longitude_c": "-101.258738",
        "portC": "3"
      },
      {
        "name": "Interface Bridge-Aggregation2: Operational status",
        "Date": "24/11/2023 10:38:02",
        "Metric": 1,
        "hostidP": 11924,
        "latitude_p": "21.0218106",
        "longitude_p": "-101.258738",
        "hostidC": 11922,
        "latitude_c": "21.1590201",
        "longitude_c": "-100.934294",
        "portC": "2"
      },
      {
        "name": "Interface Bridge-Aggregation3: Operational status",
        "Date": "24/11/2023 07:47:09",
        "Metric": 1,
        "hostidP": 11922,
        "latitude_p": "21.1590201",
        "longitude_p": "-100.934294",
        "hostidC": 11928,
        "latitude_c": "20.9039631",
        "longitude_c": "-100.713282",
        "portC": "3"
      },
      {
        "name": "Interface Bridge-Aggregation3: Operational status",
        "Date": "24/11/2023 10:37:01",
        "Metric": 1,
        "hostidP": 11928,
        "latitude_p": "20.9039631",
        "longitude_p": "-100.713282",
        "hostidC": 11921,
        "latitude_c": "20.4812",
        "longitude_c": "-100.801425",
        "portC": "3"
      },
      {
        "name": "Interface Bridge-Aggregation2: Operational status",
        "Date": "24/11/2023 10:36:58",
        "Metric": 1,
        "hostidP": 11921,
        "latitude_p": "20.4812",
        "longitude_p": "-100.801425",
        "hostidC": 11918,
        "latitude_c": "20.5097828",
        "longitude_c": "-101.0036331",
        "portC": "2"
      }
    ],
    "status_code": 200
  }

  export default data_switches